import { useState } from "react";
import Search from "../../icons/search";
import companiesApi from "../../lib/companies/companies-api";

import { BiSolidUser } from 'react-icons/bi';
import { MdGroups2 } from 'react-icons/md';

import ClipLoader from "react-spinners/ClipLoader";

import _ from 'lodash';

const icons = {
    'company': MdGroups2,
    'user': BiSolidUser
}

export default function SearchBar() {
    const [ search, setSearch ] = useState('');
    const [ results, setResults ] = useState('');
    const [ loading, setLoading ] = useState(false);

    let clearOut = null;

    const onChange = (e) => {
        const { value } = e.target;

        setSearch(value);
        getSearchResults(value);
    }

    const getSearchResults = (value) => {
        if (value?.length === 0) return setResults([]);

        setLoading(true);

        companiesApi.search(window.user?.company_id, {
            term: value,
            admin_resource: false,
        }).then(({ data }) => {
            setResults(data);
            setLoading(false);
        })
    }

    const resultsArray =  _.groupBy(results, 'type');

    return (
        <div className="search">
            <div className="search__bar">
                <Search/>
                <input 
                    className="search__input" 
                    onChange={onChange}
                    value={search}
                />
                <ClipLoader
                    color={'white'}
                    loading={loading}
                    override={{
                        borderWidth: '10px',
                    }}
                    size={20}
                    aria-label="Loading Spinner"
                    data-testid="loader"
                />
            </div>

            { results?.length > 0 && <div className="search__results">
                { Object.keys(resultsArray)?.map((key, index) => {
                    const results = resultsArray[key];
                    const Icon = icons?.[key];

                    return (
                        <div className="results-group" key={index}>
                            <h4 className="results-group__title">{ key }</h4>
                            <div className="results-group__results">
                                { results?.map((result, resultIndex) => {
                                    let link = '#';

                                    if (key === 'user') {
                                        link = `/mydmc/account/company/user/${result?.type_id}`
                                    }

                                    if (key === 'company') {
                                        link = `/mydmc/account/company`;
                                    }

                                    return <a href={link} key={resultIndex} className="search-result">
                                        <p className="search-result__name">{ result?.title }</p>
                                        { Icon && <Icon className="search-result__icon"/> }
                                    </a>
                                })}
                            </div>
                        </div>
                    )
                })}
            </div> }
        </div>
    )
}